export default {
  familyName: 'Nunito Sans',
  fullName: 'Nunito Sans 12pt Bold',
  postscriptName: 'NunitoSans12pt-Bold',
  category: 'sans-serif',
  capHeight: 705,
  ascent: 1011,
  descent: -353,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 489,
  xWidthAvg: 470,
  subsets: {
    latin: {
      xWidthAvg: 470
    },
    thai: {
      xWidthAvg: 500
    }
  }
};
